<template>
  <div class="section-main__warp">
    <div class="carbon-account">
      <div>
        <el-card shadow="never">
          <div class="carbon-account-title">
            碳排放总量（万吨CO2e）
          </div>
        </el-card>
      </div>
      <div class="carbon-account-table">
        <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
          @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          <template slot="search_statYear">
            <div>
              <el-date-picker v-model="statYear" type="year" value-format="yyyy" placeholder="请选择"
                :clearable="false"></el-date-picker>
            </div>
          </template>
          <template slot="menuLeft">
            <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-download" @click="exportList">
              导出报表
            </el-button>
          </template>
        </ioc-table>
      </div>
    </div>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/carbonAccount";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      statYear: '',
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  created() {
    let date = new Date();
    //获取年份  
    this.statYear = date.getFullYear() + '';
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      let date = new Date();
      //获取年份  
      this.statYear = date.getFullYear() + '';
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        statYear: this.statYear
      };
      this.$fetch(api.carbonAccount.queryStatistics, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    exportList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        statYear: this.statYear
      };
      this.$fetchDownLoad(api.carbonAccount.exportStatistics, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        // const blob = new Blob([content], { type: "application/zip" });
        const blob = new Blob([content]);
        const currentTime = new Date().getTime()
        const fileName = '月度碳排放记录' + currentTime + '.xlsx';
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.carbon-account {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.carbon-account-title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
}

.carbon-account-table {
  width: 100%;
  height: 93%;
}
</style>